var map = {
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"default~home-home-module~pages-gallery-gallery-module~pages-webpage-webpage-module",
		"common",
		"home-home-module"
	],
	"./pages/about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"pages-about-about-module"
	],
	"./pages/gallery/gallery.module": [
		"./src/app/pages/gallery/gallery.module.ts",
		"default~home-home-module~pages-gallery-gallery-module~pages-webpage-webpage-module",
		"common",
		"pages-gallery-gallery-module"
	],
	"./pages/image-pack-select/image-pack-select.module": [
		"./src/app/pages/image-pack-select/image-pack-select.module.ts",
		"pages-image-pack-select-image-pack-select-module"
	],
	"./pages/language-select/language-select.module": [
		"./src/app/pages/language-select/language-select.module.ts",
		"pages-language-select-language-select-module"
	],
	"./pages/settings/settings.module": [
		"./src/app/pages/settings/settings.module.ts",
		"pages-settings-settings-module"
	],
	"./pages/webpage/webpage.module": [
		"./src/app/pages/webpage/webpage.module.ts",
		"default~home-home-module~pages-gallery-gallery-module~pages-webpage-webpage-module",
		"common",
		"pages-webpage-webpage-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;